import store from '@/store';
import companySettingsApi from './companySettings';
import { isCorporateEnvironment, isCorporateMockEnabled } from './environment';

let loadingPromise = null;
let loadedOnce = false;

/**
 * Carrega settings corporativos uma vez por sessão.
 * Usado no portal do aluno (footer/logo). O admin usa /website e typeBusiness.
 */
export async function ensureCorporateSettingsLoaded(accessToken) {
    const token = accessToken || store.state?.token;
    if (!token) {
        return store.state.corporateCompanySettings;
    }

    if (!isCorporateEnvironment() && !isCorporateMockEnabled()) {
        return store.state.corporateCompanySettings;
    }

    if (loadedOnce && store.state.corporateCompanySettings) {
        return store.state.corporateCompanySettings;
    }

    if (loadingPromise) return loadingPromise;

    loadingPromise = companySettingsApi
        .get(token)
        .then((settings) => {
            const fromApi = settings?.isCorporate;
            const merged = {
                ...(settings || {}),
                // null/undefined = ainda não definido na company → não força true/false
                ...(fromApi === undefined ? {} : { isCorporate: fromApi }),
                siteEnabled: typeof settings?.siteEnabled === 'boolean'
                    ? settings.siteEnabled
                    : false,
                portal: {
                    showCertificate: settings?.portal?.showCertificate !== false,
                    showInquiry: Boolean(settings?.portal?.showInquiry),
                    showForum: Boolean(settings?.portal?.showForum),
                    bannerUrl: settings?.portal?.bannerUrl || null,
                    ...(settings?.portal || {}),
                },
            };

            store.dispatch('storeCorporateCompanySettings', { settings: merged });
            loadedOnce = true;

            if (fromApi === true || fromApi === 1 || fromApi === '1') {
                const company = store.state.company;
                if (company && typeof company === 'object' && !Array.isArray(company)) {
                    store.dispatch('storeCompany', {
                        company: {
                            ...company,
                            isCorporate: true,
                            platform_type: 'corporate',
                            siteEnabled: merged.siteEnabled,
                        },
                    });
                }
            } else if (fromApi === false || fromApi === 0 || fromApi === '0') {
                const company = store.state.company;
                if (company && typeof company === 'object' && !Array.isArray(company)) {
                    store.dispatch('storeCompany', {
                        company: {
                            ...company,
                            isCorporate: false,
                            platform_type: 'school',
                            siteEnabled: merged.siteEnabled,
                        },
                    });
                }
            }

            return merged;
        })
        .catch((error) => {
            console.warn('[corporate] falha ao carregar company settings', error);
            loadedOnce = true;
            return store.state.corporateCompanySettings;
        })
        .finally(() => {
            loadingPromise = null;
        });

    return loadingPromise;
}

export function resetCorporateSettingsCache() {
    loadedOnce = false;
    loadingPromise = null;
}

export default {
    ensureCorporateSettingsLoaded,
    resetCorporateSettingsCache,
};
